import {
  StackFlask,
  StackPython,
  StackHTML,
  StackCSS,
  StackBootstrap,
  StackGithubPages,
  StackJavascript,
  StackPostgresql,
  StackMarkdown,
  StackChatGPT,
  StackDocker,
} from "./stacks";
import cs50xemportugues01 from "../../images/projects/flask/cs50xemportugues/cs50xemportugues01.png";
import cs50xemportugues02 from "../../images/projects/flask/cs50xemportugues/cs50xemportugues02.png";
import cs50xenfrancais01 from "../../images/projects/flask/cs50xenfrancais/cs50xenfrancais01.png";
import cs50xenespanol01 from "../../images/projects/flask/cs50xenespanol/cs50xenespanol01.png";
import aprendaagora01 from "../../images/projects/flask/aprendaagora/aprendaagora01.png";

export const CS50xemPortugues: IProject = {
  title: {
    english: "Harvard University's Course Platform Builder",
    portuguese: "Criar de Plataforma do Curso da Universidade de Harvard",
  },
  slug: {
    english: "harvard-university-course-website",
    portuguese: "site-do-curso-universidade-harvard",
  },
  description: {
    english: `This automation project is a website builder for Harvard University's CS50 computer science course, where I am an instructor. This tool translates the course's content using Python and ChatGPT, and builds the course's website using Python, Flask, Bootstrap, HTML, CSS, and jQuery. 
      \nThe translation tool has processed more than 5 million words that make up the course's content. Additionally, it provides reports on the translation progress (indicating which files have been translated and which ones are yet to be translated).
      \nThe translation process also addresses ChatGPT limitations in terms of the number of words it can translate at once, given that some content files far exceed ChatGPT's word limit.
      \nThe translation tool also includes an option to generate audio files in the target language based on the course's videos, using ChatGPT's Text-to-Speech feature. This allows for the quick production of the course's videos without the need for an actual person to record the audios, which could take hundreds of hours.
      \nThis project has been used to translate and build the websites for the Portuguese, Spanish, and French versions of Harvard University's CS50 course. What makes this project special is that it literally saves thousands of hours of translation work and makes launching the course in new languages super easy.`,
    portuguese:
      "Este aplicativo traduz o conteúdo e constrói o site para o curso de ciência da computação CS50 de Harvard. Ele utiliza o ChatGPT para traduzir o conteúdo e constrói o site em arquivos estáticos usando o Frozen-Flask.",
  },
  realClient: true,
  features: {
    english: [
      "Translation automation using Python",
      "Website frozen into static files with Frozen-Flask and hosted on Github Pages.",
      "Content translation with ChatGPT.",
      "Audio file generation via ChatGPT text to speech feature.",
    ],
    portuguese: [],
  },
  stack: [
    StackFlask,
    StackPython,
    StackHTML,
    StackCSS,
    StackBootstrap,
    StackGithubPages,
    StackChatGPT,
  ],
  coverImage: cs50xemportugues01,
  coverImage2: cs50xemportugues02,
  images: [cs50xemportugues01, cs50xemportugues02],
  projectLink: "https://cs50xemportugues.github.io/",
  githubLink: "https://github.com/ramonfrombr/cs50x-website-builder",
};

export const CS50xenFrancais: IProject = {
  title: {
    english: "Harvard University's Course Platform in French",
    portuguese: "Plataforma do Curso da Universidade de Harvard em Francês",
  },
  slug: {
    english: "harvard-university-course-website-french",
    portuguese: "site-do-curso-universidade-harvard-frances",
  },
  description: {
    english:
      "This app translates the content and builds the website for Harvard's CS50 computer science course. It uses ChatGPT to translate the content and builds the website into static files using Frozen-Flask.",
    portuguese:
      "Este aplicativo traduz o conteúdo e constrói o site para o curso de ciência da computação CS50 de Harvard. Ele utiliza o ChatGPT para traduzir o conteúdo e constrói o site em arquivos estáticos usando o Frozen-Flask.",
  },
  realClient: true,
  features: {
    english: [
      "Website frozen into static files with Frozen-Flask and hosted on Github Pages",
      "Content translation with ChatGPT",
    ],
    portuguese: [],
  },
  stack: [
    StackFlask,
    StackPython,
    StackHTML,
    StackCSS,
    StackBootstrap,
    StackGithubPages,
    StackChatGPT,
  ],
  coverImage: cs50xenfrancais01,
  coverImage2: cs50xenfrancais01,
  images: [cs50xenfrancais01],
  projectLink: "https://cs50xenfrancais.github.io/",
  githubLink: "https://github.com/ramonfrombr/cs50x-website-builder",
};

export const CS50xenEspanol: IProject = {
  title: {
    english: "Harvard University's Course Platform in Spanish",
    portuguese: "Plataforma do Curso da Universidade de Harvard em Espanhol",
  },
  slug: {
    english: "harvard-university-course-website-spanish",
    portuguese: "site-do-curso-universidade-harvard-espanol",
  },
  description: {
    english:
      "This app translates the content and builds the website for Harvard's CS50 computer science course. It uses ChatGPT to translate the content and builds the website into static files using Frozen-Flask.",
    portuguese:
      "Este aplicativo traduz o conteúdo e constrói o site para o curso de ciência da computação CS50 de Harvard. Ele utiliza o ChatGPT para traduzir o conteúdo e constrói o site em arquivos estáticos usando o Frozen-Flask.",
  },
  realClient: true,
  features: {
    english: [
      "Website frozen into static files with Frozen-Flask and hosted on Github Pages",
      "Content translation with ChatGPT",
    ],
    portuguese: [],
  },
  stack: [
    StackFlask,
    StackPython,
    StackHTML,
    StackCSS,
    StackBootstrap,
    StackGithubPages,
    StackChatGPT,
  ],
  coverImage: cs50xenespanol01,
  coverImage2: cs50xenespanol01,
  images: [cs50xenespanol01],
  projectLink: "https://cs50xenespanol.github.io/",
  githubLink: "https://github.com/ramonfrombr/cs50x-website-builder",
};

export const AprendaAgoraAdmin: IProject = {
  title: {
    english: "Admin Dashboard for Language Learning Educational Platform",
    portuguese:
      "Painel Administrador para Plataforma Educativa de Ensino de Idiomas",
  },
  slug: {
    english: "language-learning-platform-admin",
    portuguese: "admin-plataforma-aprendizado-idiomas",
  },
  description: {
    english:
      "An admin dashboard for a language learning educational platform. It enables management of courses, topics, lessons, questions, and many other items that compose online language courses.",
    portuguese:
      "Velit velit incididunt dolore officia. Sunt enim officia culpa adipisicing cupidatat mollit. Reprehenderit ad culpa sunt laborum aute ad. Occaecat elit ut do nulla mollit elit cupidatat excepteur. Pariatur deserunt pariatur amet minim officia ex excepteur incididunt et consectetur non fugiat. Aliquip aute non amet esse.",
  },
  realClient: true,
  features: {
    english: [
      "Authentication (login/register with email-password)",
      "CRUD operations for questions and comments from students",
      "Content Management System for blogging",
      "Content Management System for course content",
      "Responsive UI for all screens",
    ],
    portuguese: [],
  },
  stack: [
    StackDocker,
    StackFlask,
    StackPython,
    StackJavascript,
    StackBootstrap,
    StackPostgresql,
    StackHTML,
    StackCSS,
    StackMarkdown,
  ],
  coverImage: aprendaagora01,
  coverImage2: aprendaagora01,
  images: [aprendaagora01],
  projectLink: "https://aprendaagora-website.onrender.com/",
};
